import { Col, Row, Form, Button, ButtonGroup } from 'react-bootstrap';
import { useState, useCallback, useEffect } from 'react';

import BasicSpinner from '../common/basic-spinner';
import PaginatedList from '../common/pagination';
import ListView from '../common/list-view';
import { useAuth } from "../../utils/auth-provider";
import { fetchUserImageParents, fetchUserItemParents, fetchUserCollectionParents} from "../../utils/fetch-helpers";

//================================================================

export default function AddChildren({parent, childList, onAdd, type}) {

  const user = useAuth();

  //----------------------------------------------------------------
  // Hooks

  // need to figure another solution to terminology.
  const [childrenToAdd, setChildrenToAdd] = useState([]);
  const [filterParents, setFilterParents] = useState(false);
  const [children, setChildren] = useState(childList || []);
  const [noParents, setNoParents] = useState([]);
  const [parents, setParents] = useState([]);

  //----------------------------------------------------------------
  // Functions

  const fetchParents = async () => {
    let promises = childList.map(async (child) => {
      let promise;
      switch(type){
      case 'image':
        promise = await fetchUserImageParents(user, child._id);
        break;
      case 'item':
        promise = await fetchUserItemParents(user, child._id);
        break;
      case 'collection':
        promise = await fetchUserCollectionParents(user, child._id);
        break;
      }
      return {
        child: child,
        parents: promise
      };
    });
    Promise.all(promises).then((resolved) => {setParents(resolved)});
  }

  useEffect(() => {
    setNoParents(
      parents.filter(({parents}) =>
        'items' in parents && parents['items'].length === 0
        &&
        'collections' in parents && parents['collections'].length === 0
      ).map(({child}) => child)
    );
  },[parents]);

  useEffect(() => {
    fetchParents();
  }, [children]);

  useEffect(() => {
    setChildren(childList);
  }, [childList])


  const updateChildrenToAdd = useCallback(async (checked, childId) => {
      if (checked){
        setChildrenToAdd([...new Set(
          [...childrenToAdd, childId]
        )]);
      } else {
        setChildrenToAdd(childrenToAdd.filter(id => id !== childId))
      }
  });

  //----------------------------------------------------------------

  return (

    <>
      { childList && childList.length > 0 ?
        <>
          <Row>
            <Col>{"Filters: "}</Col>
            <Col>
              <Form.Check
                type="checkbox"
                id={`filter-no-parents`}
                label={`no parents`}
                onChange={(event) => {setFilterParents(event.target.checked)}}
                disabled={noParents.length === 0}
              />
            </Col>
          </Row>

          <PaginatedList
            onSelect={updateChildrenToAdd}
            list={filterParents ? noParents : children}
            type={type}
            isPrivate={true}
          />

          <Row className="my-3 text-center">
            <Col>
              <Button
                onClick={() => onAdd(childrenToAdd)}
              >
                Add Selected as Children
              </Button>
            </Col>
          </Row>
        </>
        :
        <>No Children to Select</>
      }
    </>
  );
}
